
define('text!views/welcome.html',[],function () { return '<section>\r\n  <h2 data-bind="text:title"></h2>\r\n  <blockquote data-bind="text:subHeader, visible:subHeader"></blockquote>\r\n  <div class="row" data-bind="foreach: contactList">\r\n    <a data-bind="attr: { href:url }, text: title"></a>\r\n  </div>\r\n</section>\r\n';});

